import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionCancelPolicy as Question } from "./cancel-policy";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	cancelPolicy: StandardOptionCategoriesAndManagerStore["cancelPolicy"];
};

export const QuestionOptionCancelPolicy = ({ cancelPolicy }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper
			islandTitle="オプション独自のキャンセルポリシー"
			categoryStore={cancelPolicy}
		>
			<Question />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionOptionCancelPolicy.displayName = "QuestionOptionCancelPolicy";
